import { render } from "./DetailEquipement.vue?vue&type=template&id=49cf861a"
import script from "./DetailEquipement.vue?vue&type=script&lang=ts"
export * from "./DetailEquipement.vue?vue&type=script&lang=ts"

import "./DetailEquipement.vue?vue&type=style&index=0&id=49cf861a&lang=css"
script.render = render

export default script